/* eslint-disable max-len */
import React, { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectCurrentTeamFeePermissions } from 'containers/app/appSlice';
import { TNC } from 'containers/settings/invoiceSettings.model';
import { CustomTextArea } from 'components';
import { selectEstimateTncEdited, selectEstimatesTnc, updateEstimatesTnc } from 'containers/estimates/estimatesSlice';
import { termsMaxCount } from 'containers/settings/constants';

interface CreateEstimateTnCProps {
  className?: string;
  termsAndConditions: TNC;
  isLoadingTermsAndConditions: boolean;
}

const CreateEstimateTnC: FC<CreateEstimateTnCProps> = ({ termsAndConditions }) => {
  const feeSettingsPermissions = useAppSelector(selectCurrentTeamFeePermissions);
  const dispatch = useAppDispatch();
  const estimatesTnc = useAppSelector(selectEstimatesTnc);
  const estimateTncEdited = useAppSelector(selectEstimateTncEdited);

  useEffect(() => {
    if (termsAndConditions?.tncId && !estimateTncEdited) {
      dispatch(updateEstimatesTnc(termsAndConditions.tnc));
    }
  }, [termsAndConditions?.tncId, estimateTncEdited]);

  const handleTncChange = (value: string) => {
    dispatch(updateEstimatesTnc(value));
  };

  return (
    <>
      <h2 className={'mb-2 mt-4 text-17px font-semibold text-heading'}>Terms and Conditions</h2>
      <div className="relative">
        <CustomTextArea
          id="create-edit-estimate-tnc-input"
          name="termsAndConditions"
          value={estimatesTnc}
          onChange={handleTncChange}
          disabled={!feeSettingsPermissions.editTnc}
          className={`!min-h-[100px] w-full resize-none rounded   border border-borderGray p-2.5 text-[17px] font-normal text-primaryText focus:border-primaryBtn focus:outline-none 
                ${!feeSettingsPermissions.editTnc ? 'cursor-not-allowed bg-gray-100' : ''}`}
          placeholder="Enter terms and conditions"
          maxLength={termsMaxCount}
          showRemainingChar={true}
        />
      </div>
    </>
  );
};

export default CreateEstimateTnC;
